import { useTranslation } from 'react-i18next';

interface AccountStatusBadgeProps {
    status: 'active' | 'suspended' | 'insufficient_funds';
}

const COLORS: Record<AccountStatusBadgeProps['status'], string> = {
    active: 'bg-green-900/40 text-green-300 border-green-800/60 light:bg-green-100 light:text-green-800 light:border-green-300',
    suspended:
        'bg-red-900/40 text-red-300 border-red-800/60 light:bg-red-100 light:text-red-700 light:border-red-300',
    insufficient_funds:
        'bg-yellow-900/40 text-yellow-200 border-yellow-800/60 light:bg-yellow-100 light:text-yellow-800 light:border-yellow-300',
};

export default function AccountStatusBadge({ status }: AccountStatusBadgeProps) {
    const { t } = useTranslation('profile');
    return (
        <span
            className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded border-[0.5px] ${COLORS[status]}`}
        >
            {t(`status.${status}`)}
        </span>
    );
}
